import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CartService } from '../../../../shared/services/cart.service';
import { DataService } from '../../../../shared/data/data.service';

@Component({
    selector: 'app-popular-products',
    templateUrl: './popular-products.component.html',
    styleUrls: ['./popular-products.component.scss']
})
export class PopularProductsComponent implements OnInit {

    singleProductsBox: any[] = [];

    constructor(
        private http: HttpClient,
        private cartService: CartService,
        private data: DataService
    ) {}

    ngOnInit(): void {
        this.getProjectCategories();
        this.cartService.cartItems$.subscribe(items => {
            this.syncProductQuantities(items);
        });
    }

    syncProductQuantities(cartItems: any[]): void {
        this.singleProductsBox.forEach(product => {
            const cartItem = cartItems.find(item => item.id === product.id);
            if (cartItem) {
                product.quantity = cartItem.quantity;
                product.inCart = true;
            } else {
                product.quantity = 1;
                product.inCart = false;
            }
        });
    }

    // ─── Fetch Categories → Find "Popular Items" → Load Products ───────────────

    getProjectCategories(): void {
        this.http.post<any>(this.data.base_url + 'get_project_categories/', {}).subscribe({
            next: (response) => {
                if (response.status == 1) {
                    const categories = response.data.map((item: any) => ({
                        id: item.id,
                        name: item.category_name,
                        active: false
                    }));

                    const popularCategory = categories.find(
                        (cat: any) => cat.name.toLowerCase().trim() === 'popular items'
                    );

                    if (popularCategory) {
                        this.getProjects(popularCategory.id);
                    }
                }
            },
            error: (error) => console.error('Categories error:', error)
        });
    }

    getProjects(category?: string): void {
        const payload = category && category !== '' && category !== 'all'
            ? { category }
            : {};

        this.http.post<any>(this.data.base_url + 'get_webproject_data/', payload).subscribe({
            next: (response) => {
                if (response.status == 1 && response.data) {
                    this.singleProductsBox = response.data.map((project: any, index: number) => ({
                        mainImg: project.image && project.image !== ''
                            ? this.data.base_url + 'media/' + project.image
                            : 'assets/img/bg-1.1.jpg',
                        title: project.title,
                        newPrice: project.price ? `$${project.price}` : '',
                        oldPrice: '',
                        sale: '',
                        outOfStock: project.stock === 0 ? 'Out of Stock' : '',
                        id: project.id,
                        category: project.category,
                        detailsLink: 'menu/',
                        description: project.description,
                        image: project.image && project.image !== ''
                            ? this.data.base_url + 'media/' + project.image
                            : 'assets/img/bg-1.1.jpg',
                        price: project.price,
                        quantity: 1,
                        isFav: false,
                        justAdded: false,
                        badge: this.getBadge(index)
                    }));
                    this.syncProductQuantities(this.cartService.getCartItems());
                } else {
                    this.singleProductsBox = [];
                }
            },
            error: (error) => {
                console.error('Products error:', error);
                this.singleProductsBox = [];
            }
        });
    }

    // ─── Badge Labels ────────────────────────────────────────────────────────────

    getBadge(index: number): string {
        const badges = ['Chef Special', 'Bestseller', 'Popular', 'Fan Favorite', 'New Arrival', 'Must Try'];
        return badges[index % badges.length];
    }

    // ─── Favourite Toggle ────────────────────────────────────────────────────────

    toggleFav(item: any): void {
        item.isFav = !item.isFav;
    }

    // ─── Add to Cart with Animation ──────────────────────────────────────────────

    addToCartAnimated(item: any): void {
        if (item.justAdded) return;

        this.cartService.addToCart({
            ...item,
            quantity: 1
        });

        item.justAdded = true;

        setTimeout(() => {
            item.justAdded = false;
        }, 1200);
    }

    // ─── Quantity Helpers (if needed elsewhere) ──────────────────────────────────

    increaseQuantity(item: any): void {
        if (!item.quantity) item.quantity = 1;
        item.quantity++;
        this.updateCartQuantity(item.id, item.quantity);
    }

    decreaseQuantity(item: any): void {
        if (!item.quantity) item.quantity = 1;
        if (item.quantity > 1) {
            item.quantity--;
            this.updateCartQuantity(item.id, item.quantity);
        }
    }

    private updateCartQuantity(itemId: any, quantity: number): void {
        const cartItems = this.cartService.getCartItems();
        const itemIndex = cartItems.findIndex(item => item.id === itemId);
        if (itemIndex !== -1) {
            this.cartService.updateQuantity(itemIndex, quantity);
        }
    }
}